function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.14275 1.00012H2.57132C2.26822 1.00012 1.97753 1.12053 1.7632 1.33486C1.54887 1.54918 1.42847 1.83987 1.42847 2.14298V11.2858C1.42847 11.5889 1.54887 11.8796 1.7632 12.094C1.97753 12.3083 2.26822 12.4287 2.57132 12.4287H9.42847C9.73157 12.4287 10.0223 12.3083 10.2366 12.094C10.4509 11.8796 10.5713 11.5889 10.5713 11.2858V4.42869M7.14275 1.00012L10.5713 4.42869M7.14275 1.00012V4.42869H10.5713M8.28561 7.28584H3.71418M8.28561 9.57155H3.71418M4.85704 5.00012H3.71418",
  stroke: "#525A6E",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFileTertiary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTertiary);
export default __webpack_public_path__ + "static/media/file-tertiary.50c27a03.svg";
export { ForwardRef as ReactComponent };